import { address } from "./address/index";
import { awb } from "./awb/index";
import { calculations } from "./calculations/index";
import { coverageArea } from "./coverage-area/index";
import { credit } from "./credit/index";
import { order } from "./order/index";
import { pickup } from "./pickup/index";
import { payment } from "./payment/index";
import { profile } from "./profile/index";
import { courier } from "./courier/index";

export const services = {
    address,
    awb,
    calculations,
    coverageArea,
    credit,
    order,
    pickup,
    payment,
    profile,
    courier,
};
